var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavStick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip10"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 453,
    y: 467,
    width: 29,
    height: 28
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip10)",
    transform: "translate(-453 -467)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9167 5.25 18.375 5.25 18.375 3.5 16.9167 3.5C15.7888 3.49953 14.7194 4.00213 14 4.87083 13.2806 4.00213 12.2112 3.49953 11.0833 3.5L9.625 3.5 9.625 5.25 11.0833 5.25C12.2104 5.25128 13.1237 6.16461 13.125 7.29167L13.125 13.125 10.7917 13.125 10.7917 14.875 13.125 14.875 13.125 20.7083C13.1237 21.8354 12.2104 22.7487 11.0833 22.75L9.625 22.75 9.625 24.5 11.0833 24.5C12.2112 24.5005 13.2806 23.9979 14 23.1292 14.7194 23.9979 15.7888 24.5005 16.9167 24.5L18.375 24.5 18.375 22.75 16.9167 22.75C15.7896 22.7487 14.8763 21.8354 14.875 20.7083L14.875 14.875 17.2083 14.875 17.2083 13.125 14.875 13.125 14.875 7.29167C14.8763 6.16461 15.7896 5.25128 16.9167 5.25Z",
    fill: "current",
    transform: "matrix(1.03571 0 0 1 453 467)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavStick);
export default __webpack_public_path__ + "static/media/nav-stick.5980521e69ae8ceb6fe0428663e42cfb.svg";
export { ForwardRef as ReactComponent };